import {Candidate, CandidateRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {PersonAvatar, SoftChip} from "../../../../components/kit";
import {Stack, Typography} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";
import {fileLocalSave} from "../../../../components/form/form_inputs/form_file";
import React, {useEffect, useState} from "react";
import {TableCell} from "@mui/material";

export const useCandidate = (id: number | undefined): [(Candidate | undefined), React.Dispatch<React.SetStateAction<Candidate | undefined>>] => {
	const apiManager = useApiManager();
	const [getter, setter] = useState<Candidate | undefined>();
	const ctrl = apiManager.factory(CandidateRestControllerApiFactory);

	useEffect(() => {
		if (id) {
			apiManager
			.execute(ctrl.getCandidate(id))
			.then(c => setter(c));

		}
	}, [id]);
	return [getter, setter];
};

export const CandidateListPage = () => {
	const apiManager = useApiManager();
	const ctrl = apiManager.factory(CandidateRestControllerApiFactory);


	const listConfig: AppListConfig<Candidate> = {
		title: "Listado de candidatos ",
		onClick: "/app/admin/recruitment/candidate",
		headers: [
			{title: "Nombre"},
			{title: "Tipo"},
			{title: "Estado"},
			{title: "Puntos", align: "right"},
			{title: "Fuente"},
			{title: "Pide (bruto anual)", align: "right"},
		],
		decorator: (bean: Candidate) => (
			<>
				<TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : "inherit"}}>
					<Stack direction="row" spacing={1.5} alignItems="center" sx={{minWidth: 0}}>
						<PersonAvatar name={`${bean.name || ""} ${bean.surnames || ""}`} size={30}/>
						<Typography variant="body2" fontWeight={600} noWrap>{`${bean.name || ""} ${bean.surnames || ""}`.trim()}</Typography>
					</Stack>
				</TableCell>
				<TableCell>
					{bean.type?.name}
				</TableCell>
				<TableCell>
					{bean.state?.name ? <SoftChip tone="info" label={bean.state.name}/> : "—"}
				</TableCell>
				<TableCell align="right" sx={{fontVariantNumeric: "tabular-nums"}}>
					{bean.points ?? "—"}
				</TableCell>
				<TableCell>
					{bean.source?.label || "—"}
				</TableCell>
				<TableCell align="right" sx={{fontVariantNumeric: "tabular-nums"}}>
					{bean.reqAnnualPayroll ? Number(bean.reqAnnualPayroll).toLocaleString("es-ES") + " €" : "—"}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			return ctrl.pageCandidate(currentPage, size, undefined, term, showDismissed);
		},
		actions: [
			{
				action: () => {
					apiManager.executeRaw(ctrl.exportCandidate()).then((resp) => {
						fileLocalSave(resp);
					});
				},
				label: "Exportar"
			},
		]
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};